import React, { lazy, Suspense } from 'react';

const LazyDonHangTaiXe = lazy(() => import('./DonHangTaiXe'));

const DonHangTaiXe = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyDonHangTaiXe {...props} />
  </Suspense>
);

export default DonHangTaiXe;
